const myTranslator = (translation, lang, key) => {
    if (!translation[lang][key]) {
        let _key = key.split("_")
        return _key.slice(-1)
    } else {
        return translation[lang][key]
    }
}
export default myTranslator;